/**
 * Dynamic imports for heavy helper components
 * 
 * Use these for better code splitting and reduced initial bundle size.
 * Wrap components in Suspense when using:
 * 
 * Example:
 *   import { Suspense } from 'react'
 *   import { CustomReactPlayer } from 'src/consumer/components/helperComponents/dynamic'
 *   
 *   <Suspense fallback={<div>Loading player...</div>}>
 *     <CustomReactPlayer url={url} />
 *   </Suspense>
 */

import { lazy } from 'react'

// Heavy media components - dynamically imported (~200KB+ savings per component)
export const CustomReactPlayer = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.CustomReactPlayer,
  }))
)

export const ProfilePictureButtonComponent = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.ProfilePictureButtonComponent,
  }))
)

export const DocumentUploadComponent = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.DocumentUploadComponent,
  }))
)

// Heavy async select components (includes react-select async features)
export const CustomAsyncPaginate = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.CustomAsyncPaginate,
  }))
)

export const CustomAsyncCreatablePaginate = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.CustomAsyncCreatablePaginate,
  }))
)

// Modal components (less frequently used)
export const RegisterModal = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.RegisterModal,
  }))
)

export const ConfirmationModal = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.default, // ConfirmationModal is a default export
  }))
)

// Phone OTP component (includes ReCAPTCHA ~50KB)
export const PhoneOTPComponent = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.PhoneOTPComponent,
  }))
)

// Time range picker (less used utility)
export const TimeRangePicker = lazy(() =>
  import('../helperComponents.jsx').then((module) => ({
    default: module.TimeRangePicker,
  }))
)

